import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import Classes, { ACHFromAccount, Account, ACHBatch } from "model";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
export default function CaptureParticipantSelected02(props) {
    const context = useBCMSContext();

    BCMSRecord.globalControllerFor(Classes, context);

    const effectiveDate = BCMSDate.init().nextBusinessDay().nextBusinessDay();
    const defaultData = getDefaultData();
    const secCode = ACHBatch.getSelectedSecCodeByBranding();

    const participants = defaultData.participants.reduce((acc, item, i) => {
        if(i == 0){
            acc.push(item);
            return acc;
        }
        if(i < 2) item.isSelected = "true";
        acc.push(item);
        return acc;
    }, []);

    const { state } = context ?? {};
    const { branding } = state ?? {};
    const { options } = branding ?? {};
    const hasACHCCDNonConsumerCredit = options.nonconsumer_credit_abi22 === "true";

    const addedAccount = ACHFromAccount.init({ account: "6", id: ACHFromAccount.nextID(), amount: hasACHCCDNonConsumerCredit ?"2000.00":"3000.00" });
    let data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .update([ "oneTimeACHPayment", "secCode" ], secCode)
    .update([ "oneTimeACHPayment", "scheduleType" ], "future dated")
    .update([ "oneTimeACHPayment", "effectiveDate" ], effectiveDate)
    .update([ "oneTimeACHPayment", "companyEntryDescription" ], hasACHCCDNonConsumerCredit ? "ACH PMT" : "PAYROLL")
    .update([ "oneTimeACHPayment", "company" ], "0")
    .update([ "achFromAccounts", "accounts" ], [ addedAccount ])
    .update([ "participants" ], participants);

    if(options.offset_account_ui_abi22 === "Single Account") {
        data.update([ "selectedOffsetAccount", "account" ], Account.initByID("6"))
    }

    data = data.submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .update([ "showSecCode", "isActive" ], true)
    .update([ "achParticipantsModalIsOpen", "isActive" ], true)
    .submit();

  if(hasACHCCDNonConsumerCredit) {
          const message = `This capture is only shown when ABI22 branding option "ACH - CCD - Non-Consumer Credit" is set to "No".`;
          return <CaptureNotShownView message={ message }/>;
      }
  
      return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}